/**
 * @generated SignedSource<<b9cb266e5374c6953e7c5c686faa3a1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SeoRouteType = "ALIAS" | "PERMANENT_REDIRECT" | "REDIRECT";
import { FragmentRefs } from "relay-runtime";
export type SeoRoutesListRow_seoRoute$data = {
  readonly id: string;
  readonly monthlyDestinationVisits: number | null;
  readonly monthlySourceVisits: number | null;
  readonly packageCount: number | null;
  readonly sourceUrl: string | null;
  readonly targetUrl: string | null;
  readonly type: SeoRouteType;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity" | "SeoRouteJsonParams_seoRoute">;
  readonly " $fragmentType": "SeoRoutesListRow_seoRoute";
};
export type SeoRoutesListRow_seoRoute$key = {
  readonly " $data"?: SeoRoutesListRow_seoRoute$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeoRoutesListRow_seoRoute">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeoRoutesListRow_seoRoute",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "packageCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "monthlySourceVisits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "monthlyDestinationVisits",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoRouteJsonParams_seoRoute"
    }
  ],
  "type": "SeoRoute",
  "abstractKey": null
};

(node as any).hash = "1c2ea20492f3a8da51ed8a30ce6dba74";

export default node;
